import { AxiosResponse } from 'axios';
import { useAuth } from 'context/auth-context';
import { useQuery, UseQueryResult } from 'react-query';
import { WorkoutAthleteResultList } from 'types';
import { client } from 'utils/api-client';

// Poll every minute so coach-side edits in the Whiteboard flow into the athlete app.
const POLL_INTERVAL_MS = 60_000;

function useMyWorkoutResult(
  workoutId: string | undefined,
): UseQueryResult<AxiosResponse<WorkoutAthleteResultList | null>> {
  const { session } = useAuth();
  const athleteId = session?.athlete?.athleteId;
  return useQuery(
    ['workout-athlete-results', workoutId, athleteId],
    () =>
      client.get<WorkoutAthleteResultList | null>(
        `workout-athlete-results/my-results/?workout=${encodeURIComponent(workoutId ?? '')}`,
      ),
    { enabled: !!workoutId && !!athleteId, refetchInterval: POLL_INTERVAL_MS },
  );
}

export default useMyWorkoutResult;
